import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { ROLE_LABELS, STAFF, ADMIN, ALL } from "@/lib/nav";

const CAN_DO = {
  super_admin: "create jobs, screen and rank candidates, build assessments, make decisions, and manage settings, users and compliance.",
  recruiter: "create jobs, add candidates, build and send assessments and interviews, and move candidates through the 5 hiring steps.",
  hiring_manager: "review candidates on the jobs you're assigned to, preview assessments, compare candidates and record hiring decisions.",
};

const STEPS = [
  { roles: ALL, element: '[data-tour="sidebar-daily"]', popover: { title: "Daily work", description: "Your everyday screens: the dashboard, your jobs and every candidate." } },
  { roles: ALL, element: '[data-tour="inbox"]', popover: { title: "What needs you", description: "Everyone waiting on an action shows up here, each with one Next step button. Start your day here." } },
  { roles: STAFF, element: '[data-tour="create-job"]', popover: { title: "1. Create a job", description: "Paste or upload a job description. We turn it into editable requirements in about 30 seconds." } },
  { roles: ALL, element: '[data-tour="sidebar-pipeline"]', popover: { title: "Assessments and more", description: "Open Assessments to see, create and edit the questionnaires candidates take. Interviews and reports are here too." } },
  { roles: ALL, element: '[data-tour="next-step"]', popover: { title: "The next step bar", description: "Not sure what to do next? This bar suggests the most useful action. Hide it any time." } },
  { roles: ALL, element: '[data-tour="search"]', popover: { title: "Search", description: "Jump to any job or candidate by typing part of the name." } },
  { roles: ADMIN, element: '[data-tour="settings"]', popover: { title: "Settings", description: "Connect email, set your branding and manage who has access." } },
  { roles: ALL, popover: { title: "Inside every job: 5 steps", description: "Open a job to see the same 5 steps every time: Onboard, Screen and shortlist, Assess, Interview, Offer. Each candidate shows one Next step button." } },
];

let active = null;

export function runTour(steps, onDone) {
  if (active || !steps.length) return;
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  active = driver({
    steps,
    animate: !reduced,
    smoothScroll: !reduced,
    showProgress: steps.length > 1,
    progressText: "Step {{current}} of {{total}}",
    nextBtnText: "Next",
    prevBtnText: "Back",
    doneBtnText: "Finish",
    overlayColor: "#1B1E1A",
    overlayOpacity: 0.55,
    stagePadding: 6,
    stageRadius: 10,
    popoverClass: "tl-tour",
    onPopoverRender: (popover, { driver: d }) => {
      popover.wrapper.setAttribute("data-testid", "tour-popover");
      popover.nextButton.setAttribute("data-testid", "tour-next-btn");
      popover.previousButton.setAttribute("data-testid", "tour-back-btn");
      popover.progress.setAttribute("data-testid", "tour-step-counter");
      const skip = document.createElement("button");
      skip.innerText = "Skip tour";
      skip.className = "tl-tour-skip";
      skip.setAttribute("data-testid", "tour-skip-btn");
      skip.onclick = () => d.destroy();
      popover.footerButtons.insertBefore(skip, popover.footerButtons.firstChild);
    },
    onDestroyed: () => {
      active = null;
      onDone?.();
    },
  });
  active.drive();
}

export const pickSteps = (defs, role) => defs.filter((s) => (!s.roles || s.roles.includes(role)) && (!s.element || document.querySelector(s.element))).map(({ roles, ...s }) => s);

export function startTour(role, onDone) {
  const intro = { popover: { title: `You're signed in as ${ROLE_LABELS[role] || "a team member"}`, description: `Here's what you can do: ${CAN_DO[role] || "review candidates."}` } };
  runTour([intro, ...pickSteps(STEPS, role)], onDone);
}
